module.exports = __webpack_public_path__ + "img/callum_flanders.076722c6.jpg";